import { api } from '../../../../lib/api';

export const laborHoursService = {
  async getEmployeeYearHours(employeeId, year) {
    const params = new URLSearchParams({
      employee_id: String(employeeId),
      year: String(year),
    });
    return api.get(`/api/labor/summary/employees/hours-year?${params}`);
  },

  async generateEmployeeYearHours(employeeId, year) {
    const params = new URLSearchParams({
      employee_id: String(employeeId),
      year: String(year),
    });
    return api.post(`/api/labor/summary/employees/hours-year/generate?${params}`, {});
  },

  async getEmployeeMonthDetail(employeeId, year, month) {
    const params = new URLSearchParams({
      employee_id: String(employeeId),
      year: String(year),
      month: String(month),
    });
    return api.get(`/api/labor/summary/employees/hours-detail?${params}`);
  },
};
